import React from 'react';
import styled from 'styled-components';

const HtmlContainer = styled.div`
  margin: 0 0 52px 0;
  font-size: 16px;

  & img {
    max-width: 100%;
  }

  p {
    min-height: 16px !important;
  }
`;

const HtmlContent = ({ html }: { html: string }) => {
  return <HtmlContainer id="newsContent" dangerouslySetInnerHTML={{ __html: html }} />;
};

export default HtmlContent;
